import { StatisticData } from './types';

export const statistics: StatisticData[] = [
  {
    title: "Global Prevalence",
    value: "0.01%",
    description: "About 1 in 10,000 people have hemiplegic migraines"
  },
  {
    title: "Female to Male Ratio",
    value: "3:1",
    description: "Women are more likely to experience hemiplegic migraines"
  },
  {
    title: "Genetic Cases",
    value: "50%",
    description: "Half of cases may have a genetic component"
  }
];